import React from "react";
import { Layer, Rect } from "react-konva";

import { Area } from "../types";

// return the 4 rectangles around the given area
const getRects = (area: Area, stageWidth: number, stageHeight: number) => {
  return [
    // Top rectangle - covers area above the clear area
    {
      x: 0,
      y: 0,
      width: stageWidth,
      height: area.y,
    },
    // Bottom rectangle - covers area below the clear area
    {
      x: 0,
      y: area.y + area.height,
      width: stageWidth,
      height: stageHeight - (area.y + area.height),
    },
    // Left rectangle - covers area to the left of the clear area
    {
      x: 0,
      y: area.y,
      width: area.x,
      height: area.height,
    },
    // Right rectangle - covers area to the right of the clear area
    {
      x: area.x + area.width,
      y: area.y,
      width: stageWidth - (area.x + area.width),
      height: area.height,
    },
  ];
};

interface OverlayLayerProps {
  area: Area; // the clear area
  stageWidth: number;
  stageHeight: number;
  color?: string;
}

export const OverlayLayer = (props: OverlayLayerProps) => {
  const { area, stageWidth, stageHeight, color = "rgba(0, 0, 0, 0.5)" } = props;

  const darkOverlayRectangles = React.useMemo(
    () => getRects(area, stageWidth, stageHeight),
    [area, stageWidth, stageHeight],
  );

  return (
    <Layer>
      {darkOverlayRectangles.map((rect) => (
        <Rect
          key={`${rect.x}-${rect.y}-${rect.width}-${rect.height}`}
          {...rect}
          fill={color}
          listening={false}
        />
      ))}
    </Layer>
  );
};
